export const notification = [
    {
        conditions: [{value: 0, operator: 'gt'}, {value: 60, operator: 'lte'}],
        settings: {
            heartbitColor: 'red',
            pointColor: 'red',
            showHeartbit: true,
            showPoint: true
        }
    },
    {
        conditions: [{value: 60, operator: 'gt'}],
        settings: {
            heartbitColor: 'red',
            pointColor: 'red',
            showHeartbit: false,
            showPoint: true
        }
    }
]